import 'picturefill';
import velocity from 'velocity-animate'; // eslint-disable-line
import 'slick-carousel';

/* ==========================================================================
   Scroll to top

   Initialize:
   cargobay.scrollToTop.init();

   Support:
   Latest Chrome
   Latest FireFox
   Latest Safari
   IE9 and up
   ========================================================================== */

var cargobay = cargobay || {};

cargobay.scrollToTop = (function($, window, undefined) {

    var init,
        duration,
        defaultDuration = 300,
        $hook = $('.js-scroll-to-top');

    init = function() {
        $hook.on('click', function(e) {
            e.preventDefault();

            var $this = $(this),
                dataDuration = $this.data('animation-duration');

            duration = (typeof dataDuration !== undefined && !isNaN(dataDuration)) ? dataDuration : defaultDuration;

            $('html, body').animate({scrollTop: 0}, duration);
        });
    };

    return {
        init: init
    };

}(jQuery, window));

/* ==========================================================================
   Sidebar Toggle

   Initialize:
   cargobay.sidebarToggle.init();

   Support:
   Latest Chrome
   Latest FireFox
   Latest Safari
   IE9 and up
   ========================================================================== */

cargobay.sidebarToggle = (function($, window, undefined) {

    var activeSidebarClass = 'sidebar-toggle__sidebar--active';

    var init, toggle;

    var aniSidebarOpen = {},
        aniSidebarClose = {},
        aniContainerOpen = {},
        aniContainerClose = {};

    var sidebarWidth, sidebarHeight;

    var $btn,
        $container,
        $content,
        $sidebar,
        position = '',
        preventOverflow,
        duration = 0;


    // Init
    init = function() {
        $('.js-sidebar-toggle__toggle-btn').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            $btn = $(this),
                $container = $($btn.data('container')),
                $content = $($btn.data('content')),
                $sidebar = $($btn.data('sidebar')),
                position = $btn.data('position'),
                preventOverflow = $btn.data('prevent-overflow'),
                duration = $btn.data('duration');

            // Set direction variables
            if(position === 'left') {
                sidebarWidth = $sidebar.outerWidth();

                aniSidebarOpen.translateX = ['0', '-100%'];
                aniSidebarClose.translateX = ['-100%', '0'];

                aniContainerOpen.translateX = [sidebarWidth, '0'];
                aniContainerClose.translateX = ['0', sidebarWidth];
            }
            if(position === 'right') {
                sidebarWidth = $sidebar.outerWidth();

                aniSidebarOpen.translateX = ['0', '100%'];
                aniSidebarClose.translateX = ['100%', '0'];

                aniContainerOpen.translateX = ['-' + sidebarWidth, '0'];
                aniContainerClose.translateX = ['0', '-' + sidebarWidth];
            }
            if(position === 'top') {
                sidebarHeight = $sidebar.outerHeight();

                aniSidebarOpen.translateY = ['0', '-100%'];
                aniSidebarClose.translateY = ['-100%', '0'];

                aniContainerOpen.translateY = [sidebarHeight, '0'];
                aniContainerClose.translateY = ['0', sidebarHeight];
            }
            if(position === 'bottom') {
                sidebarHeight = $sidebar.outerHeight();

                aniSidebarOpen.translateY = ['0', '100%'];
                aniSidebarClose.translateY = ['100%', '0'];

                aniContainerOpen.translateY = ['-' + sidebarHeight, '0'];
                aniContainerClose.translateY = ['0', '-' + sidebarHeight];
            }

            // Animate toggle
            toggle();
        });
    };


    // Toggle
    toggle = function() {
        if(!$sidebar.hasClass(activeSidebarClass)) {
            $sidebar.addClass(activeSidebarClass);

            $sidebar.velocity(aniSidebarOpen, {
                duration: duration,
                easing: 'ease'
            });

            $content.velocity(aniContainerOpen, {
                duration: duration,
                easing: 'ease'
            });

            if(preventOverflow) {
                $('.sidebar-toggle-container').addClass('sidebar-toggle-container--prevent-overflow');
            }

            $content.one('click', toggle);

        } else {
            $sidebar.removeClass(activeSidebarClass);

            $sidebar.velocity(aniSidebarClose, {
                duration: duration,
                easing: 'ease'
            });

            $content.velocity(aniContainerClose, {
                duration: duration,
                easing: 'ease'
            });

            if(preventOverflow) {
                $('.sidebar-toggle-container').removeClass('sidebar-toggle-container--prevent-overflow');
            }

            $content.off('click', toggle);
        }
    };


    return {
        init: init
    };

}(jQuery, window));

/* ==========================================================================
   Toggle

   Initialize:
   cargobay.toggle.init();

   Support:
   Latest Chrome
   Latest FireFox
   Latest Safari
   IE9 and up
   ========================================================================== */

cargobay.toggle = (function($, window, undefined) {

    var init, toggle, show, hide, hideFast;

    // Config
    var defaultAnimationDuration = 150,
        animationDuration = 0,
        btnClass = 'js-toggle-btn',
        btnClassActive = 'toggle-btn--active',
        itemClassActive = 'toggle-item--active',
        itemContentClass = 'toggle-item__content';


    // Init
    init = function() {
        toggle();
    };


    // Main toggle function
    toggle = function() {
        $('.' + btnClass).on('click touchstart mousedown', function(e) {
            e.preventDefault();
        }).on('touchend mouseup', function() {
            var $this = $(this),
                $target = $($this.data('target')),
                $targetContent = $target.find('.' + itemContentClass),
                targetContentHeight = $targetContent.height(),
                currentTargetIsActive = $target.hasClass(itemClassActive),
                hideOthers = $this.data('hide-others');

            // Check if custom animation duration has been set.
            animationDuration = ($this.data('duration') !== undefined) ? $this.data('duration') : defaultAnimationDuration;


            if(currentTargetIsActive) {
                // Target is active, so hide it
                hide($this, $target);

            } else {

                // Check if others have to be cleared.
                if(hideOthers){
                    var ownTarget = $this.data('target');
                    var currentLevel = $this.data('level');

                    $.each($('.'+ btnClass +'[data-level="' + currentLevel + '"]'), function(index, value){
                        if(ownTarget !== $(value).data('target')){
                            $value = $(value);
                            var smTarget = $(value).data('target');

                            if($value.hasClass(btnClassActive)){
                                // Clear others
                                hideFast($value, $(smTarget));
                            }
                        }
                    });
                }

                // Update target
                show($this, $target, $targetContent, targetContentHeight);
            }
        });
    };


    // Show an item
    show = function($btn, $target, $targetContent, height) {
        $btn.addClass(btnClassActive);

        $target.velocity({
            height: height
        }, {
            duration: animationDuration,
            complete: function() {
                $target.css('height', 'auto');
                $target.addClass(itemClassActive);
            }
        });
    };


    // Hide an item
    hide = function($btn, $target) {
        $target.velocity({
            height: 0
        }, {
            duration: animationDuration,
            complete: function() {
                $btn.removeClass(btnClassActive);
            }
        });

        $target.removeClass(itemClassActive);
    };

    hideFast = function($btn, $target) {
        $btn.removeClass(btnClassActive);

        $target.css('height', 0);
        $target.removeClass(itemClassActive);
    };

    return {
        init: init
    };

}(jQuery, window));

import search from './search';
import demoMsg from './demoMsg';
import cookieConsent from './cookieConsent';
import videolink from './videolink';

$(() => {
    cargobay.toggle.init();
    cargobay.scrollToTop.init();
    cargobay.sidebarToggle.init();
    $(document).ready(function () {
        $(".slider").slick({
            dots: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });

    if ($(window).width() > 992) {
        $(window).scroll(function(){
            if ($(this).scrollTop() > $('.main-header--desktop .header-visual').height() - $('#navbar_top').height()) {
                $('#navbar_top').addClass("fixed-top");
                // add padding top to show content behind navbar
                $('body').css('padding-top', $('#navbar_top').outerHeight() + 'px');
            }else{
                $('#navbar_top').removeClass("fixed-top");
                // remove padding top from body
                $('body').css('padding-top', '0');
            }
        });
    }

    search();
    demoMsg();
    cookieConsent();
    videolink();
});

